import { render, staticRenderFns } from "./ConteudoDash.vue?vue&type=template&id=aa33c638&scoped=true&"
import script from "./ConteudoDash.vue?vue&type=script&lang=js&"
export * from "./ConteudoDash.vue?vue&type=script&lang=js&"
import style0 from "./ConteudoDash.vue?vue&type=style&index=0&id=aa33c638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa33c638",
  null
  
)

export default component.exports